import { useAuth } from "react-oidc-context";

export const useAuthActions = () => {
  const auth = useAuth();

  const signOutRedirect = async () => {
    await auth.removeUser();
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith("downloadCache_")) {
        localStorage.removeItem(key);
      }
    });

    sessionStorage.removeItem("savedFilesCache");

    const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID;
    const logoutUri = process.env.REACT_APP_COGNITO_LOGOUT_URI;
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;

    if (!clientId || !logoutUri || !cognitoDomain) {
      console.error("Missing Cognito environment variables.");
      return;
    }

    window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
  };

  return { auth, signOutRedirect };
};
